import type { ReactNode } from 'react';

export const symbol_fitness_trackers: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m155-101-36-118q-18-12-28.5-31.5T80-293v-374q0-23 11-43t29-32l36-117q3-10 10.5-15.5T184-880h192q10 0 17.5 5.5T404-859l36 117q18 12 29 32t11 43v374q0 23-10.5 42.5T441-219l-36 118q-3 10-11 15.5T376-80H184q-10 0-18-5.5T155-101Zm51-39h147l20-63H186l20 63Zm-36-123h220q13 0 21.5-8.5T420-293v-374q0-13-8.5-21.5T390-697H170q-13 0-21.5 8.5T140-667v374q0 13 8.5 21.5T170-263Zm17-494h185l-19-63H206l-19 63ZM625-80q-24 0-42-18t-18-42v-474h-10q-12 0-21-9t-9-21v-42q0-12 9-21t21-9h10v-104q0-24 18-42t42-18h195q24 0 42 18t18 42v104h11q13 0 20.5 9t7.5 21v42q0 12-7.5 21t-20.5 9h-11v474q0 24-18 42t-42 18H625Zm0-555v495h195v-495H625Zm0-60h195v-125H625v125ZM280-203Zm0-554Z"
		/>
	</svg>
);
